import { Input } from "@components/ui-kit/Input";
import classNames from "classnames";
import styles from "./styles.module.scss";

interface FormInputWrapperProps {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (val: string) => void;
  type?: "number" | "text";
  optional?: boolean;
  className?: string;
}

export const FormInputWrapper = ({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  optional,
  className,
}: FormInputWrapperProps) => (
  <div className={styles.inputWrapper}>
    <Input
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      type={type}
      style={{ width: "100%", fontFamily: "Roboto" }}
      className={classNames(styles.custom, className)}
      optional={optional}
    />
  </div>
);
